import { of, EMPTY } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { ofType } from "redux-observable";
import { propOr } from "ramda";
import { types } from "../../actions/county";
import * as actions from "../../actions";
import userGetters from "../../getters/user";

export const fetchTenantConfiguration = (actionStream, state$) =>
  actionStream.pipe(
    ofType(types.SET),
    mergeMap(({ payload }) => {
      const isLoggedIn = userGetters.isLoggedIn(state$.value);

      const curConfiguration = propOr(
        null,
        payload,
        state$.value.configuration
      );

      if (isLoggedIn && payload && !curConfiguration) {
        return of(actions.configuration.fetch({ tenant: payload }));
      }

      return EMPTY;
    })
  );

export default [fetchTenantConfiguration];
